module.exports = __webpack_public_path__ + "37ba7b92/img/arrow-share-icon.00a12c29.svg";